import React from 'react'
import { Box, Typography, useTheme } from '@mui/material'
import { useTranslation } from 'react-i18next'

const EmptyHistoryState: React.FC = () => {
  const { t } = useTranslation()
  const theme = useTheme()
  
  return (
    <Box sx={{
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      justifyContent: 'center',
      textAlign: 'center',
      height: 'calc(100% - 70px)',
      pb: 0
    }}>
      <Box sx={{
        width: 80,
        height: 80,
        borderRadius: '50%',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        backgroundColor: theme.palette.grey[100],
        marginBottom: 3
      }}>
        <i className="fa-light fa-list-timeline" style={{ fontSize: 35, color: theme.palette.grey[500] }} />
      </Box>
      <Typography sx={{
        fontSize: 14,
        color: theme.palette.grey[600],
        maxWidth: '70%'
      }}>
        {t('auth.history.no_history', 'Aucun historique disponible pour cet utilisateur')}
      </Typography>
    </Box>
  )
}

export default EmptyHistoryState
